import type { MarketplaceKey } from "@porsche-customer/slfinrtl-context-types"

export const getMinimumSubsidizedUsageTime = (marketplaceKey: MarketplaceKey): number | undefined => {
	switch (marketplaceKey) {
		case "de":
			return 90
		case "us":
			return 30
		case "au":
			return 180
	}
}
